import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SummaryCard from "components/widget/SummaryCard";
import { LucideCalendar, LucideCircleCheck, LucideCircleX, LucideClock } from "lucide-react";
import WeeklyAttendanceOverview from "./components/WeeklyAttendanceOverview";
import CalendarView from "./components/CalendarView";
import { getMonthlyAttendanceSummary } from "../../../redux/overview/overviewState";
import { getHolidayList } from "../../../redux/holiday/holidayState";

import EmployeeAttendanceTable from "./components/EmployeeAttendanceTable";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const { MonthPicker } = DatePicker;
const AttendanceOverview = () => {
	const dispatch = useDispatch();
	const recordList = useSelector((state) => state.overview.monthlyAttendanceRecord?.data?.totals);
	const holidayList = useSelector((state) => state.holiday.holidayList?.items);
	
	const [calendarValue, setCalendarValue] = useState(dayjs());
	const [selectedDay, setSelectedDay] = useState(null);

	const startDate = calendarValue.startOf("month").format("YYYY-MM-DD");
	const endDate = calendarValue.endOf("month").format("YYYY-MM-DD");

	useEffect(() => {
		dispatch(getMonthlyAttendanceSummary());
	}, [dispatch, startDate, endDate]);

	useEffect(() => {
		dispatch(getHolidayList());
	}, [dispatch]);
	
	return (
		<div>
			<div className="inline-flex mt-4">
				<MonthPicker
					className="w-[150px]"
					value={calendarValue}
					format="MMMM YYYY"
					placeholder="Select month"
					onChange={(date) => {
						if (!date) return;
						setCalendarValue(date.startOf("month"));
						setSelectedDay(null); // optional reset
					}}
				/>
			</div>
			<div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-4">
				<SummaryCard
					title={"Total Present"}
					icon={<LucideCircleCheck size={16} className="text-green-600"/>}
					displayCount={recordList?.total_present_days}
					description={"Days this month"}
					textColor="text-green-600"
				/>	

				<SummaryCard
					title={"Total Absent"}
					icon={<LucideCircleX size={16} className="text-red-600"/>}
					displayCount={recordList?.total_absent_days}
					description={"Days this month"}
					textColor="text-red-500"
				/>

				<SummaryCard
					title={"Late Arrivals"}
					icon={<LucideClock size={16} className="text-orange-600"/>}
					displayCount={recordList?.total_late_days}
					description={"Instances this month"}
					textColor="text-orange-600"
				/>		
				
				<SummaryCard
					title={"Avg. Attendance"}
					icon={<LucideCalendar size={16} className="text-black-600"/>}
					displayCount={`${recordList?.attendance_rate}%`}
					description={"This month"}
					textColor="text-slate-900 dark:text-white"
				/>	
			</div>
			<div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-6">
				<div className="lg:col-span-2">
					<WeeklyAttendanceOverview />
				</div>

				<div>
					<CalendarView
						calendarValue={calendarValue}
						setCalendarValue={setCalendarValue}
						selectedDay={selectedDay}
						setSelectedDay={setSelectedDay}
					/>
				</div>
			</div>
			<div className="mt-6">
      			<EmployeeAttendanceTable 
					startDate={startDate} 
					endDate={endDate} />
			</div>
		</div>
    );
};

export default AttendanceOverview;